/* Minimaru — Anniversary Sale page · FAQ accordion */
(function () {
  function init() {
    document.querySelectorAll('.ann-faq-question').forEach(function (btn) {
      if (btn.dataset.annBound) return;
      btn.dataset.annBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.ann-faq-item');
        var wasOpen = item.classList.contains('ann-open');
        document.querySelectorAll('.ann-faq-item.ann-open').forEach(function (i) {
          i.classList.remove('ann-open');
        });
        if (!wasOpen) item.classList.add('ann-open');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
